"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var imageSources = [{
  media: '(max-width: 418px)',
  srcsetList: [{
    template: '180x240_standard'
  }, {
    template: '180x240_retinax2',
    scale: '1.5x'
  }, {
    template: '180x240_retinax2',
    scale: '2x'
  }]
}, {
  media: '(max-width: 527px)',
  srcsetList: [{
    template: '234x312_standard'
  }, {
    template: '234x312_retinax2',
    scale: '1.5x'
  }, {
    template: '234x312_retinax2',
    scale: '2x'
  }]
}, {
  media: '(min-width: 528px)',
  srcsetList: [{
    template: 'plp_360x480_x1'
  }, {
    template: 'plp_360x480_x2',
    scale: '1.5x'
  }, {
    template: 'plp_360x480_x2',
    scale: '2x'
  }]
}];
var _default = exports["default"] = imageSources;